import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  // Cambiar API
  constructor(
    private common: CommonService,
    private http: HttpClient,
  ) {}

  getUserbyId(id: any) {
    const url = `${AppSettings.API_URI_V2}/users/${id}`;
    return this.common.getData(url, false, 0);
  }

  /**
   * Localiza una persona de la plataforma por su correo COMPLETO Y EXACTO, para
   * asociarla a un abono de temporada. No es un typeahead: el backend solo
   * acepta el filtro `email` y solo con coincidencia exacta, a propósito, para
   * que un admin no pueda «pescar» usuarios sin conocer ya su correo (ver
   * UserController::search y UserFilter). Enviar cualquier otro parámetro
   * —`search`, nombre, NIF— devuelve 422.
   */
  searchUsersByCompany(companyId: number, email: string) {
    const url = `${AppSettings.API_URI_V2}/companies/${companyId}/users-search?email=${encodeURIComponent(email)}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err)),
    );
  }

  getPreferencias() {
    const url = `${AppSettings.API_URI}/preferencias`;
    return this.common.getData(url, false, 0);
  }

  getEventsCompany(idCompany: number, page: number = 1, items: number = 12) {
    let url = `${AppSettings.API_URI_V2}/public/events?id_company=${idCompany}&sort=start_date:asc&page=${page}&per_page=${items}`;
    return this.common.getData(url);
  }

  getEventsSpaces(idSpace: number, page: number = 1, items: number = 12) {
    let url = `${AppSettings.API_URI_V2}/public/events?id_space=${idSpace}&sort=start_date:asc&page=${page}&per_page=${items}`;
    return this.common.getData(url);
  }

  putUser(userId: number, formUser: any) {
    const url = `${AppSettings.API_URI_V2}/users/${userId}`;
    return this.http.put<any>(url, formUser).pipe(
      map((data) => {
        if (data) {
          return data;
        } else return of(false);
      }),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  changePassword(userId: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/users/${userId}/password-update`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        if (data) {
          return data;
        } else return of(false);
      }),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  deleteUser(userId: number) {
    const url = `${AppSettings.API_URI_V2}/users/${userId}`;
    return this.http.delete<any>(url).pipe(
      map((data) => {
        if (data) {
          return of(true);
        } else {
          return of(false);
        }
      }),
      catchError((err) => {
        return of(false);
      }),
    );
  }

  uploadFilePut(payload: any, userId: number) {
    const url = `${AppSettings.API_URI_V2}/users/${userId}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  sendMailCreatePwd(user) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const url = `${AppSettings.API_URI_V2}/auth/reset-password`;
    return this.http.post<any>(url, { email: user }, formHeaders).pipe(
      map((data) => {
        if (data) {
          return data;
        } else return of(false);
      }),
      catchError((err) => {
        return of(false);
      }),
    );
  }

  sendSMS(phone: string) {
    const url = `${AppSettings.API_URI_V2}/auth/sms-verification`;
    return this.http.post<any>(url, { phone }).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err)),
    );
  }

  validateSMS(code: string) {
    const url = `${AppSettings.API_URI_V2}/auth/validate-sms-code`;
    return this.http.post<any>(url, { code }).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err)),
    );
  }

  getSavedCardsUser() {
    const url = `${AppSettings.API_URI_V2}/users/saved-cards`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  deleteSavedCardUser(idCard: number) {
    const url = `${AppSettings.API_URI_V2}/users/saved-cards/${idCard}`;
    return this.http.delete<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }
}
